import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'months',
  standalone: false
})
export class MonthsPipe implements PipeTransform {
  /**
   * Transforma un número de días en meses (30 días = 1 mes).
   * Ejemplo: 720 => '24 meses'
   * @param days Número de días
   * @returns Cadena con la cantidad de meses
   */
  transform(days: number): string {
    if (typeof days !== 'number' || isNaN(days) || days < 0) return '0 meses';
    const months = Math.floor(days / 30);
    if (months === 1) return '1 mes';
    return `${months} meses`;
  }
}
